import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from 'store'
import { FormattedMessage } from 'react-intl'

import { getReservationAmounts } from 'winearound-shared/utils/reservations'
import { isPaymentDisabled } from 'utils'

import Cart from 'components/Cart'
import CartSummary from 'components/CartSummary'
import EventPaymentInstructions from 'components/EventPaymentInstructions'

import {
  updateReservationData,
  clearReservation as clearReservationAction,
  create,
  fetchUuid,
  finalize,
  updateReservationAndQuery,
} from 'actions/reservation'
import { authenticationRequest as authenticationRequestAction } from 'actions/authentication'

export class Reservation extends React.Component {
  constructor(props) {
    super(props)

    this.backToEvent = this.backToEvent.bind(this)
  }

  componentDidMount() {
    const {
      fetchReservationUuid,
      // updateAll,
      match,
    } = this.props
    const { reservationUuid } = match.params

    if (reservationUuid) {
      fetchReservationUuid(reservationUuid)
    }
  }

  backToEvent(e) {
    e.preventDefault()
    e.stopPropagation()
    const { pathname, search } = window.location
    const url = `${
      pathname
        .replace('/reservation', '')
        .replace(`/${this.props.match.params.reservationUuid}/finalize`, '')
    }${search}`
    return history.replace(url)
  }

  render() {
    const {
      reservation,
      events,
      authenticationRequest,
      updateData,
      clearReservation,
      createReservation,
      match,
    } = this.props

    const { cellarId, eventId, reservationUuid } = match.params
    if (reservationUuid && (!reservation.uuid || !events[eventId])) {
      return null
    }

    const event = events[eventId][reservation.data.language]
    if (!event) {
      return null
    }

    const {
      cellar: { company },
      metaData,
      extras: eventExtras,
      disableAuth,
    } = event
    const {
      data: {
        guests,
        extras: reservationExtras = {},
      },
      step,
      coupon,
    } = reservation

    const eventPaymentDisabled = isPaymentDisabled(event, reservation.data)
    const extras = Object.keys(reservationExtras).map((extraId) => {
      const { price } = eventExtras.find((e) => e.id === extraId)
      const quantity = reservationExtras[extraId]
      return {
        price,
        quantity,
      }
    })
    const thisDate = event.dates.find(({ d }) => d === reservation.data.start)
    const specificEvent = JSON.parse(JSON.stringify(event))
    if (thisDate) {
      specificEvent.price.value = thisDate.pri
    }
    const { amount } = getReservationAmounts(
      { guests, extras },
      coupon.coupon,
      specificEvent
    )
    const paymentDisabled = !specificEvent.payment.enabled || eventPaymentDisabled || !amount
    const { currency } = specificEvent.location

    const paymentInfo = (
      <div>
        <h2 className="beta space--bottom-1">
          <FormattedMessage id={`app.cart.step.${step}.info.title`} />
        </h2>
        <p className="space--both-1">
          <FormattedMessage id={`app.cart.step.${step}.info.text`} />
        </p>
        { (step !== 'auth' && !event.hidePrice)
          ? <EventPaymentInstructions
            paymentDisabled={paymentDisabled}
            payment={specificEvent.payment}
            currency={specificEvent.location.currency}
            price={specificEvent.price.value}
            priceMode={specificEvent.price.mode}
            guests={guests}
            coupon={coupon}
            eventExtras={eventExtras}
            reservationExtras={reservationExtras}
            customPaymentText={event.payment_text}
            customProductText={event.default_product_plural}
          />
          : null
        }
      </div>
    )

    const ReservationCart = React.createFactory(Cart)({
      cart: reservation,
      cellarId,
      updateCart: updateData,
      cartOperation: reservationUuid
        ? (id, data) => this.props.finalizeReservation(reservationUuid, data)
        : createReservation,
      clearCart: clearReservation,
      paymentDisabled,
      resourceId: eventId,
      authenticationRequest,
      event: specificEvent,
      metaData,
      company,
      disableAuth,
      paymentInfo,
      amount,
      currency,
      summaryComponent: CartSummary,
      backLinkText: 'app.cart.reservation.back',
      backLinkFunction: this.backToEvent,
      finishButtonText: 'app.cart.book-now',
    })

    return ReservationCart
  }
}

Reservation.propTypes = {
  reservation: PropTypes.object.isRequired,
  events: PropTypes.object.isRequired,
  authenticationRequest: PropTypes.func.isRequired,
  updateData: PropTypes.func.isRequired,
  updateAll: PropTypes.func.isRequired,
  clearReservation: PropTypes.func.isRequired,
  createReservation: PropTypes.func.isRequired,
  fetchReservationUuid: PropTypes.func.isRequired,
  finalizeReservation: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    reservation: state.reservation,
    events: state.events,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    authenticationRequest: authenticationRequestAction,
    updateData: updateReservationData,
    updateAll: updateReservationAndQuery,
    clearReservation: clearReservationAction,
    createReservation: create,
    fetchReservationUuid: fetchUuid,
    finalizeReservation: finalize,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Reservation)
